<div #playerWrapper class="jw-app-player-component">
  <div #streamerElement [id]="elementId" class="jw-resize-preset"></div>
  <app-jwplayer-overlay *ngIf="showOverlay" [width]="videoWidth" [height]="videoHeight" [sensor]="sensor"></app-jwplayer-overlay>
</div>